import type { PermissionExpr } from '@/lib/permissions/check'
import { ADMIN_MODULES } from './modules'

/**
 * Gate do item "Admin" do RAIL: o OR dos `require` dos cards do hub (`ADMIN_MODULES`), derivado — card novo entra no
 * rail sem ninguém lembrar. Sem nenhum card, o rail não aponta pra um hub vazio (o defeito de `check.ts`, que já tirou
 * `transmission_groups:read` do `ADMIN_ACCESS` pelo mesmo motivo).
 *
 * NÃO substitui `ADMIN_ACCESS`: o layout do /admin segue nele, e é o `channels:read` de lá que deixa o atendente abrir
 * `/admin/channels/{id}` pelo link direto do "Vincular listas" (`AvisoDeListasVazias`). O rail é mais estreito.
 * dstorres passa sem o role no OR: o back entrega todas as permissions pra ele.
 */
export const ADMIN_HUB_ACCESS: PermissionExpr = { or: ADMIN_MODULES.map((m) => m.require) }
